export default __webpack_public_path__ + "static/branding6-02c8d20a464900b2baad76aa291b3944.webp";